"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bootstrap5_1 = require("./templates/bootstrap5");
const translations_1 = require("./translations");
exports.default = {
    framework: 'bootstrap5',
    templates: {
        bootstrap5: bootstrap5_1.default,
    },
    translations: translations_1.default,
};
